import InventoryItem from "./InventoryItem";

export default InventoryItem;
